document.addEventListener(
  'change',
  function (event) {
    const swatch = event.target.closest(
      'input[data-single-option-selector]'
    );

    if (!swatch) return;

    const form = swatch.closest('form.product-form');
    if (!form) return;

    const variantSelector = form.querySelector('select[name="id"]');
    if (!variantSelector) return;

    const selectedOptions = Array.from(
      form.querySelectorAll(
        'input[data-single-option-selector]:checked'
      )
    )
      .sort((a, b) => {
        const aIndex = Number(a.dataset.index.replace(/\D/g, ''));
        const bIndex = Number(b.dataset.index.replace(/\D/g, ''));
        return aIndex - bIndex;
      })
      .map(input => input.value);

    const selectedTitle = selectedOptions.join(' / ');

    const matchingVariant = Array.from(
      variantSelector.options
    ).find(option =>
      option.textContent.trim() === selectedTitle
    );

    if (!matchingVariant) return;

    variantSelector.value = matchingVariant.value;
    variantSelector.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  },
  true
);